import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';

import './discovery-creators-filters-general-header.scss';

applyTranslations(require('./discovery-creators-filters-general-header.i18n.json'));

type Props = {
  onResetFilters: () => void
};

const msgKey = 'discovery_creators_filters_general_header';

class DiscoveryCreatorsFiltersGeneral extends React.PureComponent<Props> {
  renderIcon(): React.ReactNode {
    const { onResetFilters } = this.props;

    return (
      <div
        className="discovery-creators-filters-general-header__icon"
        onClick={onResetFilters}
      >
        <Tooltip
          message={__t(`${msgKey}.tooltips.reset_filters`)}
          width="auto-compact"
        >
          <SVGDynamicIcon
            name="rotate-left-custom-fg"
            width={16}
            height={14}
            customColor="white"
          />
        </Tooltip>
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-creators-filters-general-header">
        <div className="discovery-creators-filters-general-header__label">
          {__t(`${msgKey}.labels.filters`)}
        </div>
        {this.renderIcon()}
      </div>
    );
  }
}

export default DiscoveryCreatorsFiltersGeneral;
